import { mapJsonLdSchemas } from './mapPageDataGql'
import { resolveUpdatedAt } from './gqlMapUtils'

/** Map schemaPlaceholderPage GraphQL item → SchemaPlaceholderRepository.getByPath shape. */
export function mapSchemaPlaceholderGql(item) {
  if (!item) {
    return null
  }

  return {
    path: item.path ?? null,
    jsonLdSchemas: mapJsonLdSchemas(item.jsonLdSchemasCollection?.items),
    contentType: 'schemaPlaceholderPage',
    key: item.sys?.id ?? null,
    updatedAt: resolveUpdatedAt(item),
  }
}
